"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function activeElement(doc) {
    if (doc === void 0) { doc = document; }
    try {
        return doc.activeElement;
    }
    catch (e) { }
}
exports.activeElement = activeElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/util/dom-helpers/active-element.js
// module id = 467
// module chunks = 0 1 2 3 4 5 6